import EventBus from "@plugins/common/service/eventbus";
export const AlgebraKitEventBus = new EventBus();
